export default {
  modal: {
    show: false,
    type: ''
  },
  alert: {
    show: false,
    msg: ''
  },
  confirm: {
    show: false
  },
  goToLogin: false,
  showGuide: false,
  userInfo: {
    char_info: {},
    utype: 0,
    users: [{
      char_name: '',
      head: 0
    }, {
      char_name: '',
      head: 0
    }, {
      char_name: '',
      head: 0
    }, {
      char_name: '',
      head: 0
    }, {
      char_name: '',
      head: 0
    }],
  },
  userStatus: 0,
  updateStyle: false,
  loading: false
}
